const { parseDomain } = require('parse-domain')
const languageMap = require('../../i18n/languageMap')
const invert = require('lodash/invert')
const dev = process.env.NODE_ENV !== 'production'
const domainMap = invert(languageMap)

module.exports = (language, req) => {
  if (typeof window === 'undefined' && !req) return false

  let hostname = ''
  let pathname = ''

  if (req) {
    hostname = req.hostname
    pathname = req.path
  } else {
    hostname = window.location.hostname
    pathname = window.location.pathname
  }

  if (hostname.indexOf('localhost') !== -1) {
    return `http://localhost:1666${pathname}`
  }

  if (hostname.indexOf('staging') !== -1) {
    return `https://staging.com.ticketswap.pizza${pathname}`
  }

  if (dev) {
    const { domain, topLevelDomains, subDomains } = parseDomain(hostname)
    const topLevelDomain = topLevelDomains[0]
    const ngrokHandle = subDomains[1]
    // Split domain from map at `.ticketswap.`
    // www.ticketswap.at -> ['www', 'at']
    const domainParts = domainMap[language].split('.ticketswap.')
    // Remove `www` entries from array
    // ['www', 'at'] -> ['at']
    const cleanArray = domainParts.filter(entry => entry !== 'www')
    // Transform multiple entries into one
    // ['com', 'br'] -> ['com-br']
    const transformedArray = cleanArray.map(entry => {
      const parts = entry.split('.')
      return parts.join('-')
    })
    // Join array entries.
    // ['fr', 'be'] -> 'fr-be'
    // ['at'] -> 'at'
    const devLanguage = transformedArray.join('-') || 'com'
    return `https://${devLanguage}.${ngrokHandle}.${domain}.${topLevelDomain}${pathname}`
  }

  return `https://${domainMap[language]}${pathname}`
}
